/* TODO (Delorean): Enums locais enquanto a errata/nota complementar não é persistida. Quando o backend expuser o tipo no
schema, substituir pelos gerados em `graphql/types.generated`. */
export enum TipoErrataNotaComplementarEnum {
  ERRATA = 'ERRATA',
  NOTA_COMPLEMENTAR = 'NOTA_COMPLEMENTAR',
}

export enum JustificativaErrataNotaComplementarEnum {
  INFORMACAO_INCORRETA = 'INFORMACAO_INCORRETA',
  REGISTRO_PACIENTE_INCORRETO = 'REGISTRO_PACIENTE_INCORRETO',
  INFORMACAO_INCOMPLETA = 'INFORMACAO_INCOMPLETA',
  INFORMACAO_DESATUALIZADA = 'INFORMACAO_DESATUALIZADA',
  OUTRO = 'OUTRO',
}

export const tipoErrataNotaComplementarRecord: Record<TipoErrataNotaComplementarEnum, string> = {
  [TipoErrataNotaComplementarEnum.ERRATA]: 'Errata',
  [TipoErrataNotaComplementarEnum.NOTA_COMPLEMENTAR]: 'Nota complementar',
}

export const justificativaErrataNotaComplementarRecord: Record<JustificativaErrataNotaComplementarEnum, string> = {
  [JustificativaErrataNotaComplementarEnum.INFORMACAO_INCORRETA]: 'Informação incorreta/erro de preenchimento',
  [JustificativaErrataNotaComplementarEnum.REGISTRO_PACIENTE_INCORRETO]: 'Registro realizado em paciente incorreto',
  [JustificativaErrataNotaComplementarEnum.INFORMACAO_INCOMPLETA]: 'Informação incompleta',
  [JustificativaErrataNotaComplementarEnum.INFORMACAO_DESATUALIZADA]: 'Informação desatualizada',
  [JustificativaErrataNotaComplementarEnum.OUTRO]: 'Outro',
}

export const justificativasPorTipoErrataNotaComplementarRecord: Record<
  TipoErrataNotaComplementarEnum,
  JustificativaErrataNotaComplementarEnum[]
> = {
  [TipoErrataNotaComplementarEnum.ERRATA]: [
    JustificativaErrataNotaComplementarEnum.INFORMACAO_INCORRETA,
    JustificativaErrataNotaComplementarEnum.REGISTRO_PACIENTE_INCORRETO,
  ],
  [TipoErrataNotaComplementarEnum.NOTA_COMPLEMENTAR]: [
    JustificativaErrataNotaComplementarEnum.INFORMACAO_INCOMPLETA,
    JustificativaErrataNotaComplementarEnum.INFORMACAO_DESATUALIZADA,
    JustificativaErrataNotaComplementarEnum.OUTRO,
  ],
}

export interface ErrataNotaComplementarModel {
  justificativa: JustificativaErrataNotaComplementarEnum
  descricao: string
}
